import styles from "./Expert.module.scss";
import { Characteristics } from "@/pages/MainPage/ui/Expert/Characteristics";
import { boxes } from "@/pages/MainPage/const";
import { Box } from "@/pages/MainPage/ui/Expert/Box";

export const Expert = () => {
    return (
        <div className={styles.expert}>
            <div className={styles.information}>
                <Characteristics
                    title={"Outstanding expert"}
                    text={
                        <>
                            O. G. Torsunov is an outstanding expert in{" "}
                            <span>key sciences:</span> medicine, astrology,
                            relationships, personal growth, and also possesses
                            unique experience and methods for identifying
                            problems. This allows him to find solutions to
                            life’s challenges of practically any level of
                            complexity.
                        </>
                    }
                />
                <Characteristics
                    title={"Immersion in the situation"}
                    text={
                        <>
                            During a consultation, Oleg Gennadyevich{" "}
                            <span>carefully delves into the situation</span>,
                            applying all his knowledge and skills to find the
                            best solution. What for an ordinary person is a
                            series of problems and doubts, for him is a clear
                            pattern with a guaranteed result.
                        </>
                    }
                />
                <Characteristics
                    title={"1000+ successful consultations"}
                    text={
                        <>
                            Over the past 30 years, O. G. Torsunov has conducted
                            <span>more than 1000</span> successful personal
                            consultations. Every person who sought help{" "}
                            <span>
                                received a solution to their issue directly
                                during the consultation,
                            </span>{" "}
                            or a clear action plan that quickly led them to
                            success.
                        </>
                    }
                />
            </div>
            <div className={styles.boxes}>
                {boxes.map((box, index) => {
                    if (box.isYear) {
                        return (
                            <Box
                                key={box.title}
                                yearList={box.content}
                                title={box.title}
                                index={index}
                            />
                        );
                    } else {
                        return (
                            <Box
                                key={box.title}
                                textList={box.content}
                                title={box.title}
                                index={index}
                            />
                        );
                    }
                })}
            </div>
        </div>
    );
};
